/**
* @ngdoc directive
* @name Store Item
*
* @description
  Edit Store form
*
* @scope
* @param {Object} item - store
* @param {Object} storeForm - form where store is edited
* @param {Boolean} oneStore - make all the fields required
*
* @example
  <form name='storeForm' ng-init='newStore={};'>
    <store-item item="newStore" store-form="storeForm" one-store="false"></store-item>
  </form>
*/

app.directive('storeItem', ["PATH", "apiService", function (PATH, apiService) {
  return {
    restrict: 'E',
    scope: {
      item: '=',
      storeForm: '=',
      oneStore: '=',
      caption: '=?'
    },
    templateUrl: PATH.components + 'storeItemDirective/storeItem.html',
    controller: ["$scope", function ($scope) {
      $scope.selectedState = {};
      $scope.entityTypes = [
            { name: 'Corporation (Form 1120)', id: 0 },
            { name: 'S-Corporation (Form 112S)', id: 1 },
            { name: 'Partnership (Form 1065)', id: 2 },
            { name: 'Sole Proprietor (Form 1040)', id: 3 }
      ];

      if (!$scope.item.contact) $scope.item.contact = {};

      apiService.getSome('possystems')
        .then(function (res) {
          $scope.posSystems = res.data;
        });


      $scope.$watch('selectedState.id', function (value) {
        if (value && $scope.item) {
          $scope.item.contact.state = $scope.selectedState.caption;
          $scope.item.contact.stateAbbr = $scope.selectedState.abbreviation;
          $scope.item.contact.stateId = $scope.selectedState.id;
        }
      });

      $scope.isEmpty = function (element) {
        if ($scope.oneStore || !element) return;

        // element.$modelValue is Object in select and String in input field
        var value = angular.isObject(element.$modelValue) ? element.$modelValue.caption : element.$modelValue;

        return Boolean(!value && (element.$touched || $scope.storeForm.submitted));
      };
    }]
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/storeItemDirective/storeItemDirective.js